"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawAll = exports.close = exports.open = exports.get = exports.quote = void 0;
exports.quote = "You are a recent graduate of [water|Waterwarks School] for [wave|Magically Talented Youth]. \n  \n  With your new [water|water]-based magic, you applied to become a [fire|firefighter] specializing in rescuing pets! \n  \n  Not wanting to wait any longer, you dive into the nearest [rainbow|rift] towards a [fire|burning] building...\n  \n  Make it through all 10 houses and save the most pets to graduate [fire|fire academy]!\n  ";
var common_sidecar_1 = require("../../../main/common-sidecar");
var rogueMonofont_sidecar_1 = require("../monofont/rogueMonofont-sidecar");
var rogueGlyphs_sidecar_1 = require("../targeting/rogueGlyphs-sidecar");
var _obj = null;
var get = function () {
    if (!_obj) {
        _obj = {
            isOpen: false,
            elapsed: 0,
        };
    }
    return _obj;
};
exports.get = get;
var open = function () {
    var obj = (0, exports.get)();
    obj.elapsed = 0;
    obj.isOpen = true;
};
exports.open = open;
var close = function () {
    var obj = (0, exports.get)();
    obj.isOpen = false;
};
exports.close = close;
var drawAll = function () {
    var obj = (0, exports.get)();
    if (!obj.isOpen) {
        return;
    }
    obj.elapsed += common_sidecar_1.common.getUpdateDelta();
    var x = 2;
    var y = 2;
    var w = 30;
    var ts = rogueMonofont_sidecar_1.rogueMonofont.measureWrapped(w, exports.quote);
    var h = ts.h + 2;
    rogueGlyphs_sidecar_1.rogueGlyphs.writeDialog(x, y, w, h, 'The Story So Far', exports.quote, obj.elapsed);
    // rogueMonofont.write(x, y, 'Story!')
    // y++
    // rogueMonofont.writeWrapped(
    //   x,
    //   y,
    //   30,
    //   quote,
    //   rogueDef.colors.light,
    //   rogueDef.colors.darkBlue,
    //   obj.elapsed,
    // )
};
exports.drawAll = drawAll;
